import { ApplicationRef, ComponentRef, createComponent, Injectable, Injector, Type } from "@angular/core";
import { PopupComponent } from "../../modal/popup/popup.component";
import { Observable, Subject, tap } from "rxjs";

@Injectable({ providedIn: 'root' })
export class PopupService {
  private popupRef?: ComponentRef<PopupComponent>;
  private actionSubject?: Subject<{ action: string; payload: any }>;
  constructor(
    private appRef: ApplicationRef,
    private injector: Injector
  ) {}



  open<T>(contentComponent: Type<T>, data?: any):Observable<any> | void {
    if (this.popupRef) return;

    this.actionSubject = new Subject();

    const popupRef = createComponent(PopupComponent, {
      environmentInjector: this.appRef.injector,
      elementInjector: this.injector,
    });

    this.popupRef = popupRef;
    this.appRef.attachView(popupRef.hostView);

    const domElem = popupRef.location.nativeElement;
    document.body.appendChild(domElem);

    popupRef.instance.isVisible = true;
    popupRef.instance.setContent(contentComponent, data);
    popupRef.instance.detech = () => this.close(); // override close handler


    return this.actionSubject.asObservable().pipe(
      tap((res) => {
        if (res.action === 'CLOSE') {
          this.close();
        }
      })
    );
  }

  emitAction(action: { action: string; payload: any }) {
    this.actionSubject?.next(action);
  }



  close() {
    this.actionSubject?.complete();
    this.actionSubject = undefined;

    if(this.popupRef) {
      this.popupRef.instance.isVisible = false;
    }
    setTimeout(() => {
      if (this.popupRef) {
        this.appRef.detachView(this.popupRef.hostView);
        this.popupRef.destroy();
        this.popupRef = undefined;
      }
    },800)
  }
}
